export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const STORE_USER_PERMISSIONS = 'STORE_USER_PERMISSIONS';

export const STORE_ITEMS = 'STORE_ITEMS';
export const STORE_ITEMS_TREE = 'STORE_ITEMS_TREE';

export const STORE_ACCOUNTS = 'STORE_ACCOUNTS';
export const STORE_ACCOUNTS_TREE = 'STORE_ACCOUNTS_TREE';

export const STORE_DEFAULT_WAREHOUSE = 'STORE_DEFAULT_WAREHOUSE';

export const STORE_FISCAL_YEARS = 'STORE_FISCAL_YEARS';

export const STORE_RECEIVES_STATICS = 'STORE_RECEIVES_STATICS';

export const STORE_MATERIAL_JOURNALS = 'STORE_MATERIAL_JOURNALS';

export const STORE_STATISTICS = 'STORE_STATISTICS';
export const STORE_PROVIDER_STATISTICS = 'STORE_PROVIDER_STATISTICS';

export const STORE_INVENTORY = 'STORE_INVENTORY';

export const STORE_ACCOUNTS_CONFIGS = 'STORE_ACCOUNTS_CONFIGS';
export const STORE_ITEMS_CONFIGS = 'STORE_ITEMS_CONFIGS';
export const STORE_ACCOUNTS_TREES = 'STORE_ACCOUNTS_TREES';

export const STORE_ROLES = 'STORE_ROLES';

export const RESET = 'RESET';

export const STORE_ITEMS_STATISTICS = 'STORE_ITEMS_STATISTICS'

export const STORE_CARDAMMON_INSORTING = 'STORE_CARDAMMON_INSORTING'